/**
 * Mapping of amenity URL slugs (used in ssdr ALP routes) to their
 * corresponding filter values in the `amenities` query-param array.
 *
 * Only includes slugs that correspond to a checkbox in the amenities
 * filter group. Size-based slugs (mini-self-storage, etc.) are handled
 * separately by the API and do not have a matching filter checkbox.
 */
const AMENITY_SLUG_TO_FILTER = {
	// CLP slugs
	'climate-controlled': 'climateControlled',
	'24-hour-access': 'twentyFourHourAccess',
	'drive-up-self-storage': 'driveUp',
	'free-truck-rental': 'freeTruckRental',
	electricity: 'power',
	// NMP slugs (where they differ from CLP)
	'24-hour': 'twentyFourHourAccess',
	'drive-up': 'driveUp',
};

/**
 * Extracts the amenity slug from a URL pathname.
 *
 * @param {string} pathname - e.g. "/self-storage/texas/austin/drive-up-self-storage"
 * @returns {string|null} The slug (e.g. "drive-up-self-storage") or null
 */
export function parseAmenityFromPath(pathname) {
	if (!pathname || typeof pathname !== 'string') {
		return null;
	}

	const slugs = Object.keys(AMENITY_SLUG_TO_FILTER).join('|');
	const pattern = new RegExp(`\\/(${slugs})\\/?$`, 'i');
	const match = pathname.match(pattern);

	return match ? match[1] : null;
}

/**
 * Returns the amenities-array filter value for a given amenity slug.
 *
 * @param {string} amenitySlug - e.g. "drive-up-self-storage"
 * @returns {string|null} The filter value (e.g. "driveUp") or null
 */
export function getFilterValueForAmenity(amenitySlug) {
	return AMENITY_SLUG_TO_FILTER[amenitySlug] || null;
}
